<script setup>
import { computed } from 'vue';
import { HISTORIC_MODULE_NAME, ITEMS_LIST_MODULE_NAME, useStore } from "../plugins/store";
import TreeViewSearchItemsList from "./treeViewSearchList.vue";
import { NAV, TA1, TA2 } from "../../ta";

const props = defineProps({
  currentTaId: Number,
});

const ta1Historic = useStore().getters[HISTORIC_MODULE_NAME + '/historicBySiteAccessAndTaId']({taId: TA1});
const ta2Historic = useStore().getters[HISTORIC_MODULE_NAME + '/historicBySiteAccessAndTaId']({taId: TA2});
const ta1HistoricNotEmpty = computed(() => ta1Historic.length > 0);
const ta2HistoricNotEmpty = computed(() => ta2Historic.length > 0);
const showTa1and2Historic = computed(() =>
    [TA1, TA2].includes(props.currentTaId) && (ta1HistoricNotEmpty.value ||  ta2HistoricNotEmpty.value)
);
if (showTa1and2Historic.value) {
  useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/setItems', { items: [...ta2Historic, ...ta1Historic] });
}

const ta4Historic = useStore().getters[HISTORIC_MODULE_NAME + '/historicBySiteAccessAndTaId']({taId: NAV});
const showTa4Historic = computed(() => props.currentTaId === NAV && ta4Historic.length > 0);
if (showTa4Historic.value) {
  useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/setItems', { items: ta4Historic });
}

const showHistoric = computed(() => showTa1and2Historic.value || showTa4Historic.value);
</script>

<template>
  <div v-if="showHistoric" class="search-historic">
    <div class="item-search-historic">
      <p @mousedown.prevent class="item-search-historic__title">
        <strong>{{ $t("search.tree-view.historic") }}</strong>
      </p>
      <div class="item-search-historic__Container">
        <template v-if="showTa1and2Historic">
          <template v-if="ta2HistoricNotEmpty">
            <p @mousedown.prevent class="item-search-historic__title item-search-historic__title_ta">
              <strong>{{ $t("search.tree-view.historic.ta2") }}</strong>
            </p>
            <TreeViewSearchItemsList :items="ta2Historic"/>
          </template>
          <template v-if="ta1HistoricNotEmpty">
            <p @mousedown.prevent class="item-search-historic__title item-search-historic__title_ta">
              <strong>{{ $t("search.tree-view.historic.ta1") }}</strong>
            </p>
            <TreeViewSearchItemsList :items="ta1Historic"/>
          </template>
        </template>
        <template v-else-if="showTa4Historic">
          <TreeViewSearchItemsList :items="ta4Historic"/>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '../../../../../assets/css/theme/helpers/variables';

.item-search-historic__title {
  color: variables.$body-color;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 10px 15px 0px 15px;

  &_ta {
    font-size: 13px;
  }

  .item-search .icon-container{
    padding: 8px 0px 6px 0px;
  }
}
.item-search-historic__Container {
  padding-bottom: 10px;
}

</style>
